/**
 * Common error messages used across attribute validators
 */
export const ERROR_MESSAGES = {
  VALUE_MUST_BE_STRING: "Value must be a string",
  VALUE_CANNOT_BE_EMPTY: "Value cannot be empty",
  INVALID_MEDIA_QUERY_LIST: "Invalid media query list",
} as const;
